module.exports = __webpack_public_path__ + "img/night-clear.4528f73f.svg";